import { Badge, Popover, Stack, Table, Text, UnstyledButton } from '@mantine/core';

import { type DataSourceStatus, useDataSources } from '../administracja/api';
import { useMe } from '../auth/api';

const STATUS: Record<DataSourceStatus, { color: string; label: string }> = {
  ok: { color: 'green', label: 'OK' },
  error: { color: 'red', label: 'Błąd' },
  empty: { color: 'gray', label: 'Brak' },
};

function fmt(d: string | null): string {
  return d ? new Date(d).toLocaleString('pl-PL') : '—';
}

export function DataFreshness() {
  const isAdmin = useMe().data?.is_admin ?? false;
  const sources = useDataSources(isAdmin);

  if (!isAdmin) {
    return null;
  }

  const rows = sources.data ?? [];
  // Najświeższe udane odświeżenie spośród źródeł (daty ISO sortują się chronologicznie).
  const latest = rows
    .map((r) => r.last_refreshed_at)
    .filter((d): d is string => d !== null)
    .sort()
    .at(-1);

  return (
    <Popover position="bottom-end" withArrow shadow="md" width={340}>
      <Popover.Target>
        <UnstyledButton title="Świeżość danych — kliknij po podział na źródła">
          <Text size="xs" c="dimmed">
            Dane z: {fmt(latest ?? null)}
          </Text>
        </UnstyledButton>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack gap="xs">
          <Text fw={600} size="sm">
            Źródła danych
          </Text>
          <Table fz="xs" verticalSpacing={4}>
            <Table.Tbody>
              {rows.map((s) => (
                <Table.Tr key={s.code}>
                  <Table.Td>{s.name}</Table.Td>
                  <Table.Td>
                    <Badge size="xs" variant="light" color={STATUS[s.status].color}>
                      {STATUS[s.status].label}
                    </Badge>
                  </Table.Td>
                  <Table.Td style={{ whiteSpace: 'nowrap' }} ta="right">
                    {fmt(s.last_refreshed_at)}
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
